<template>
  <wsp-modal>
    <v-form ref="form"
            v-model="valid"
            v-on:submit.prevent="()=> {return false}">
      <v-card class="pb-5 elevation-0">
        <v-card-title class="pa-0">
          <v-toolbar class="primary"
                     dark
                     dense
                     flat>
            <v-toolbar-title>
              {{ $t('godfather.godson.mail.title')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon
                   @click="visible = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>

        <v-card-text>
          <v-layout row
                    wrap>
            <v-flex xs12
                    sm12
                    class="px-2">

              <advice color="primary" class="ml-0">
                <span class="my-2"
                      v-html="$t('godfather.godson.mail.advice')"></span>
              </advice>

              <v-combobox v-model="emails"
                          hide-selected
                          :hint="$t('godfather.godson.mail.placeholder.inviteFriends')"
                          :label="$t('godfather.godson.mail.placeholder.inviteFriends')"
                          multiple
                          :rules="usernameListRules"
                          persistent-hint
                          deletable-chips
                          required
                          small-chips></v-combobox>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat
                 round
                 color="primary"
                 class="capitalize"
                 @click="visible = false">
            {{$t('global.button.cancel')}}
          </v-btn>
          <v-btn :disabled='!valid'
                 :loading="isLoading"
                 type="submit"
                 color="accent"
                 class="capitalize white--text mr-4"
                 @click="submit"
                 round
                 outline>
            {{$t('global.button.send')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </wsp-modal>
</template>

<script>
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';
import godfatherService from '@/services/godfatherService';
import WspModal from '@/components/commons/WspModal';
import Advice from '@/components/commons/Advice';
import _ from 'lodash';

export default {
  name: 'Mail',
  components: {
    [WspModal.name]: WspModal,
    [Advice.name]: Advice
  },
  watch: {
    visible: function(value) {
      if (!value) {
        this.$emit('on-close', {});
      }
    }
  },
  computed: {
    usernameListRules() {
      return [
        v => v.length !== 0 || this.$i18n.t('global.validation.required.text'),
        v => {
          return (
            _.every(v, it => {
              return /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(it);
            }) || this.$i18n.t('global.validation.email.format')
          );
        }
      ]
    }
  },
  data() {
    return {
      emails: [],
      visible: true,
      isLoading: false,
      valid: false
    };
  },
  methods: {
    async submit() {
      let isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return false;
      }

      this.isLoading = true;

      let emails = {
        friends: this.emails.join(',')
      }

      let resp = await godfatherService.invite(emails);
      if (!resp.error) {
        this.$emit('on-close', {});

      EventBus.$emit(keys.eventOnShowNotification, {
          title: '',
          message: this.$i18n.t('godfather.share.email.success'),
          type: 'info',
          doNotTranslate: true
        });
      }

      this.isLoading = false;
    }
  }
};
</script>
